import ProfileMenu from './ProfileMenu.vue';

export default ProfileMenu;



// WEBPACK FOOTER //
// ./src/pages/profile/profilemenu/index.ts